export const environment = {
  apiUrl: 'https://api.mistbelle.win/graphql',
  oneSignalAppId: 'c289e857-881c-484c-9e89-c8add75497d7',
};
